<template>
  <div class="container">
    <div class="mwow-top-title">
      <span class="text">物品服务</span>
    </div>
    <div style="margin-bottom: 24px">
      <div class="mwow-button-filled success" @click="handleCreate">
        添加项目
      </div>
    </div>
    <el-form :model="searchInfo" inline class="search-form" size="mini">
      <el-form-item label="名称:" prop="title">
        <el-input
          v-model="searchInfo.title"
          placeholder="物品名称"
          @change="handleSearch"
          prefix-icon="el-icon-search"
          clearable
          maxlength="99"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型:" prop="category_id">
        <el-select
          v-model.number="searchInfo.category_id"
          placeholder="请选择"
          @change="handleSearch"
          clearable
        >
          <el-option
            v-for="item in categoryList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="名称" prop="title"></el-table-column>
      <el-table-column label="类型" prop="category_id">
        <template slot-scope="scope">
          <span v-if="scope.row.category_id === 1">物品</span>
          <span v-if="scope.row.category_id === 2">服务</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="240"
        prop="create_time"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div
            class="mwow-button primary"
            style="margin-right: 10px"
            @click="handleEdit(scope.row)"
          >
            编辑
          </div>
          <div class="mwow-button danger" @click="handleDelete(scope.row)">
            删除
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 新建/编辑弹窗 -->
    <detail-dialog
      :visible.sync="dialogVisible"
      :origin-data="dialogData"
      @change="handleDialogChange"
    ></detail-dialog>
  </div>
</template>
<script>
import {
  getProductListApi,
  createProductApi,
  editProductApi,
  deleteProductApi,
} from "@/api/product";
import { dateFormat } from "@/utils/timeFormat";
import detailDialog from "./detailDialog.vue";
export default {
  components: {
    detailDialog,
  },
  data() {
    return {
      searchInfo: {
        title: "",
        category_id: "",
      },
      categoryList: [
        { key: 1, value: "物品" },
        { key: 2, value: "服务" },
      ],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      dialogVisible: false,
      dialogData: {},
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.title) {
        option.title = this.searchInfo.title;
      }
      if (this.searchInfo.category_id) {
        option.category_id = this.searchInfo.category_id;
      }
      getProductListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(item.create_time * 1000)
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = params.page;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleCreate() {
      this.dialogData = {
        product_id: 0,
        title: "",
        category_id: 1,
      };
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("确定要删除商品？", `删除 - ${row.title}`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      })
        .then(() => {
          deleteProductApi({ product_id: row.product_id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handleRefresh();
          });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogData = row;
    },
    handleDialogChange(e) {
      if (e === "refresh") {
        this.handleRefresh();
      } else {
        this.handleSearch();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
